// extracted by mini-css-extract-plugin
module.exports = {"reportForm":"style__reportForm__k5NMr","shapeReport":"style__shapeReport__oSOoc"};